// extracted by mini-css-extract-plugin
export default {"root":"Immunity_root__iLN5g","bubbleRoot":"Immunity_bubbleRoot__66Ysi","bubble":"Immunity_bubble__IOMsw","pilot":"Immunity_pilot__wDJ5m"};